import { Component } from "@angular/core";

@Component({
    selector: "app-pelipals",
    templateUrl: "./pelipals.page.html",
    styleUrls: ["./pelipals.page.scss"]
})
export class PelipalsPage {}
